import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useWallet } from '@solana/wallet-adapter-react';
import useNotification from '../../hooks/useNotification';

export function ProtectedRoute() {
    const { isAuthenticated } = useAuth();
    const { connected } = useWallet();
    const { notify } = useNotification();

    if (!connected) {
        notify('Please connect your wallet.', 'warning');
        return <Navigate to="/" replace />;
    }

    if (!isAuthenticated) {
        notify('Authentication failed. Please ensure you are using the same wallet you logged in with.', 'warning');
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
} 